import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useParams, useLocation } from "react-router-dom";
import { albums as localAlbums } from "./albums.js";
import { normalizeLang, translations } from "../../i18n"; 
import { useSelector } from "react-redux";
import axios from "../../api/axios";
import domen from "../../api/domen";
import "./Album.css";

const Album = () => {
  const { id } = useParams();
  const location = useLocation();
  const [album, setAlbum] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});
  const [isLightboxVisible, setIsLightboxVisible] = useState(false);
  const [lightboxClass, setLightboxClass] = useState("");

  const user = useSelector((state) => state.user.data);

  const lang = normalizeLang(user?.languageCode);
  const t = translations[lang];

  useEffect(() => {
    const mapPhotos = (obj) => {
      if (!obj) return null;
      return {
        ...obj,
        photos: (obj.photos || []).map((p) =>
          p && p.startsWith("https") ? p : `${domen}${p}`
        ),
      };
    };

    const stateAlbum = location.state?.album;
    if (stateAlbum) {
      setAlbum(mapPhotos(stateAlbum));
      return;
    }

    if (id && id.startsWith("local-")) {
      const idxStr = id.replace("local-", "");
      const idx = Number(idxStr);
      if (!Number.isNaN(idx) && localAlbums[idx]) {
        setAlbum(mapPhotos(localAlbums[idx]));
        return;
      }
    }

    const fetchAlbum = async () => {
      try {
        const { data } = await axios.get(`/api/albums/${id}`);
        setAlbum(mapPhotos(data));
      } catch (err) {
        console.error("Album load error", err);
      }
    };

    fetchAlbum();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleImageLoad = (index) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  };

  const showPrev = () => {
    setActiveIndex((prev) => (prev === 0 ? album.photos.length - 1 : prev - 1));
  };

  const showNext = () => {
    setActiveIndex((prev) => (prev === album.photos.length - 1 ? 0 : prev + 1));
  };

  const openLightbox = (index) => {
    setActiveIndex(index);
    setIsLightboxVisible(true);
    setLightboxClass("");
    requestAnimationFrame(() => {
      setLightboxClass("show");
    });
  };

  const closeLightbox = () => {
    setLightboxClass("hide");
    setTimeout(() => {
      setIsLightboxVisible(false);
      setActiveIndex(null);
      setLightboxClass("");
    }, 300);
  };

  const downloadImage = () => {
    const url = album.photos[activeIndex];
    const filename = url.split("/").pop() || "download.jpg";

    if (window.Telegram?.WebApp?.downloadFile) {
      window.Telegram.WebApp.downloadFile({
        url,
        file_name: filename,
      });
    } else {
      console.warn("Telegram WebApp.downloadFile не поддерживается");
    }
  };

  if (!album) return null;

  return (
    <>
      <div className="contentLabel">
        <div style={{ display: "flex", alignItems: "center" }}>
          <svg
            style={{ marginRight: "8px" }}
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.33333 0C1.4925 0 0 1.4925 0 3.33333V10.8333V11.6667C0 13.5075 1.4925 15 3.33333 15H11.6667C13.5075 15 15 13.5075 15 11.6667V10.8333V3.33333C15 1.4925 13.5075 0 11.6667 0H3.33333ZM3.33333 1.66667H11.6667C12.5875 1.66667 13.3333 2.4125 13.3333 3.33333L13.3367 8.49665C12.6883 7.89499 12.0275 7.51833 11.3017 7.5C11.2758 7.49917 11.2767 7.5 11.25 7.5C10.3025 7.5 9.24917 8.22833 8.54167 9.14083C8.36083 8.73249 8.17834 8.32917 7.96834 7.9425C6.98501 6.12667 5.91083 5.0025 4.58333 5C3.455 4.9975 2.48667 5.92 1.66 7.18333L1.66667 3.33333C1.66667 2.4125 2.4125 1.66667 3.33333 1.66667ZM10.8333 3.33333C10.3733 3.33333 10 3.70667 10 4.16667C10 4.62667 10.3733 5 10.8333 5C11.2933 5 11.6667 4.62667 11.6667 4.16667C11.6667 3.70667 11.2933 3.33333 10.8333 3.33333ZM4.58333 6.66667C5.06833 6.6675 5.80501 7.42249 6.51001 8.72416C6.79001 9.23916 7.04083 9.80666 7.26583 10.365C7.40083 10.6983 7.50501 10.9533 7.55168 11.0933C7.77918 11.7742 8.7025 11.8708 9.0625 11.25C9.09833 11.1883 9.16333 11.07 9.27083 10.9117C9.45083 10.645 9.65583 10.375 9.86999 10.13C10.405 9.51667 10.9208 9.16667 11.25 9.16667C11.5825 9.175 12.0958 9.52417 12.63 10.13C12.8467 10.3758 13.0467 10.645 13.2292 10.9117C13.2867 10.995 13.295 11.0342 13.3333 11.0933V11.6667C13.3333 12.5875 12.5875 13.3333 11.6667 13.3333H3.33333C2.4125 13.3333 1.66667 12.5875 1.66667 11.6667V10.9633C1.71917 10.815 1.78917 10.6392 1.90084 10.365C2.12834 9.80666 2.37499 9.23999 2.65666 8.72416C3.36749 7.41999 4.09917 6.66583 4.58333 6.66667Z"
              fill="black"
            />
          </svg>
          <p>{t.titleAlbum} {album?.[`title_${lang}`]}</p>
        </div>
      </div>

      <div className="albumGrid">
        {album.photos.map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`${album.title} ${i + 1}`}
            className={`gridImg ${loadedImages[i] ? "loaded" : ""}`}
            onClick={() => openLightbox(i)}
            onLoad={() => handleImageLoad(i)}
          />
        ))}
      </div>

      {isLightboxVisible &&
        createPortal(
          <div className={`lightbox ${lightboxClass}`} onClick={closeLightbox}>
            <button
              className="navArrow left"
              onClick={(e) => {
                e.stopPropagation();
                showPrev();
              }}
            >
              ‹
            </button>

            <img
              src={album.photos[activeIndex]}
              alt="full"
              className="lightboxImg"
              onClick={(e) => e.stopPropagation()}
            />

            <button
              className="downloadIconFixed"
              onClick={(e) => {
                e.stopPropagation();
                downloadImage();
              }}
              title="Скачать"
            >
              <div style={{ display: "flex", color: "white" }}>
                <svg
                  style={{ marginRight: "7px" }}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.99999 11.575C7.86666 11.575 7.74166 11.5543 7.62499 11.513C7.50833 11.4717 7.39999 11.4007 7.29999 11.3L3.7 7.7C3.5 7.5 3.404 7.26666 3.412 7C3.42 6.73333 3.516 6.5 3.7 6.3C3.9 6.1 4.13766 5.996 4.413 5.988C4.68833 5.98 4.92566 6.07566 5.125 6.275L6.99999 8.15V1C6.99999 0.71667 7.09599 0.479337 7.28799 0.288003C7.47999 0.0966701 7.71733 0.000670114 7.99999 3.44827e-06C8.28266 -0.000663218 8.52033 0.0953368 8.71299 0.288003C8.90566 0.48067 9.00133 0.718003 8.99999 1V8.15L10.875 6.275C11.075 6.075 11.3127 5.979 11.588 5.987C11.8633 5.995 12.1007 6.09933 12.3 6.3C12.4833 6.5 12.5793 6.73333 12.588 7C12.5967 7.26666 12.5007 7.5 12.3 7.7L8.69999 11.3C8.59999 11.4 8.49166 11.471 8.37499 11.513C8.25833 11.555 8.13333 11.5757 7.99999 11.575ZM2 16C1.45 16 0.979332 15.8043 0.587999 15.413C0.196666 15.0217 0.000666666 14.5507 0 14V12C0 11.7167 0.096 11.4793 0.288 11.288C0.48 11.0967 0.717333 11.0007 0.999999 11C1.28267 10.9993 1.52033 11.0953 1.713 11.288C1.90566 11.4807 2.00133 11.718 2 12V14H14V12C14 11.7167 14.096 11.4793 14.288 11.288C14.48 11.0967 14.7173 11.0007 15 11C15.2827 10.9993 15.5203 11.0953 15.713 11.288C15.9057 11.4807 16.0013 11.718 16 12V14C16 14.55 15.8043 15.021 15.413 15.413C15.0217 15.805 14.5507 16.0007 14 16H2Z"
                    fill="white"
                  />
                </svg>
                <p>{t.download}</p>
              </div>
            </button>

            <button
              className="navArrow right"
              onClick={(e) => {
                e.stopPropagation();
                showNext();
              }}
            >
              ›
            </button>
          </div>,
          document.body
        )}
    </>
  );
};

export default Album;
